export default __webpack_public_path__ + "static/media/nature.f8d829ad.svg";